import { Link } from "react-router-dom";
import { priceRows } from "@/mocks/pricing";

export default function PricingSnapshot() {
  const rows = priceRows.slice(0, 5);
  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-background-50 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            Quick pricing
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-[1.05]">
            Guide prices,<br />
            <em className="not-italic text-accent-600">clearly written.</em>
          </h2>
          <p className="mt-4 text-foreground-600 max-w-md">
            These are honest guide prices for local work. Final cost depends on
            the job, access, parts and urgency — but you'll always be told the
            likely cost before the work goes ahead.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/book"
              className="group inline-flex items-center gap-2 px-5 py-3.5 rounded-full bg-primary-950 text-background-50 text-sm font-semibold hover:bg-primary-900 transition-all hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
            >
              Check Availability
              <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
            </Link>
            <Link
              to="/pricing"
              className="inline-flex items-center gap-2 px-5 py-3.5 rounded-full border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Full pricing
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden">
            <div className="hidden sm:flex px-5 md:px-7 py-4 text-[11px] uppercase tracking-[0.16em] text-foreground-500 border-b border-background-200">
              <div className="flex-1">Service</div>
              <div className="w-24 text-right">From</div>
            </div>
            {rows.map((r) => (
              <div
                key={r.service}
                className="flex items-center gap-3 px-4 sm:px-5 md:px-7 py-4 sm:py-5 border-b border-background-200 last:border-b-0 hover:bg-background-100 transition-colors"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-accent-700 shrink-0">
                  <i className={`${r.icon}`}></i>
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm md:text-base font-semibold text-foreground-950 truncate">
                    {r.service}
                  </p>
                  <p className="text-xs md:text-sm text-foreground-600 line-clamp-2">{r.note}</p>
                </div>
                <div className="shrink-0 text-right">
                  <span className="text-base sm:text-lg md:text-2xl font-heading font-semibold text-accent-700 whitespace-nowrap">
                    {r.from}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
            Prices are guide prices for local work. You'll always be told the likely
            cost before the job goes ahead.
          </p>
        </div>
      </div>
    </section>
  );
}